module.exports = {
    signUpForm: {
        pickupTitle: 'Click & Collect',
        pickupDescription: 'Collect your groceries from a local store for FREE',
        fulfilmentSelectionTitle: 'How would you like to receive your groceries?',
        benefitCardCheckboxText: 'I have a Seniors or Pensioners card',
        benefitCardNumberText: 'Please enter your card identification number',
        benefitCardNumberPatternError: 'Please remove any spaces, symbols or letters that aren’t on your card.',
        agreeToTsAndCsErrorMessage: 'To sign up you must accept the above terms.',
        freeSampleTitle: 'Samples (A whole lot of great food to try. Free!)',
        freeSampleDescription: 'Would you like to receive free samples from time to time?',
        shopperTsAndCsUrl: '/shop/discover/about-us/terms-and-conditions',
        businessTsAndCsUrl: '/shop/discover/shopping-online/my-business-terms-and-conditions',
        commsTitle: 'Promotional and Marketing Communication Preferences',
        tsAndCsTitle: 'Woolworths Online Terms and Conditions',
        reminderNote: '*Please note, you can change these preferences at any time by logging into your account.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/sign-up-form.js